import {
  GetStaticPaths,
  GetStaticProps,
  InferGetStaticPropsType,
  NextPage
} from 'next'
import { Box, Text, Flex, Anchor } from '@/components/primitives'
import Layout from '@/components/Layout'
import { useEffect } from 'react'
import { Footer } from '@/components/home/Footer'
import { Head } from '@/components/Head'
import { useRouter } from 'next/router'
import { useAccount } from 'wagmi'
import { HomeHero } from '@/components/home/HomeHero'
import { Welcome } from '@/components/home/Welcome' 
import { InvestmentCalc } from '@/components/home/InvestmentCalc'
import { ItWork } from '@/components/home/ItWork'
import { InvestmentFeatures } from '@/components/home/InvestmentFeatures'
import { UsersSay } from '@/components/home/UsersSay'
import { CloudMining } from '@/components/home/CloudMining'
import { GlobleInfo } from '@/components/home/GlobleInfo'
import { ReferralPlan } from '@/components/home/ReferralPlan'
import { OpeTicket } from '@/components/home/OpeTicket'
import { PaymentMethod } from '@/components/home/PaymentMethod'
import { Leadership } from '@/components/home/leadership'
import { CopToken } from '@/components/home/CopToken'
import { Tokenomics } from '@/components/home/Tokenomics'
import DistributionChart from '@/components/home/DistributionChart'
const IndexPage: NextPage = () => {
  const { isConnected, address } = useAccount()
  const router = useRouter()

  useEffect(() => {
    let referralId = router?.query?.referralId || ''
    if (Number(referralId) > 0) {
      sessionStorage.setItem("referralId", referralId);
    }
    if (Number(router?.query?.ownId) > 0)
      sessionStorage.setItem("ownId", router?.query?.ownId);

  }, [])

  return (
    <Layout>
      <Head />
      <Box
        css={{
          p: 24,
          height: '100%',
          '@bp800': {
            p: '$6',
          },
        }}
      >
        <Box className='z-10 overflow-hidden pt-[80px] md:pt-[150px] md:pb-[120px] xl:pt-[120px] xl:pb-[160px] 2xl:pt-[120px] 2xl:pb-[200px]'>
          <HomeHero />
        </Box>
        <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2' }} className='z-10 overflow-hidden pt-[80px] md:pt-[150px] md:pb-[120px] xl:pt-[120px] xl:pb-[160px] 2xl:pt-[80px] 2xl:pb-[80px]'>
          <Welcome />
        </Box>
        <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2' }} className='z-10 overflow-hidden pt-[80px] md:pt-[150px] md:pb-[120px] xl:pt-[120px] xl:pb-[160px] 2xl:pt-[80px] 2xl:pb-[80px]'>
          <CopToken />
        </Box>
        <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2' }} className='z-10 overflow-hidden pt-[80px] md:pt-[150px] md:pb-[120px] xl:pt-[120px] xl:pb-[160px] 2xl:pt-[80px] 2xl:pb-[80px]'>
          <DistributionChart />
        </Box>
        <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2' }} className='z-10 overflow-hidden pt-[80px] md:pt-[150px] md:pb-[120px] xl:pt-[120px] xl:pb-[160px] 2xl:pt-[80px] 2xl:pb-[80px]'>
          <Tokenomics />
        </Box>

        <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2' }} className='z-10 overflow-hidden pt-[80px] md:pt-[150px] md:pb-[120px] xl:pt-[120px] xl:pb-[160px] 2xl:pt-[80px] 2xl:pb-[80px]'>
          <CloudMining />
        </Box>
        <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2' }} className='relative z-10 py-16 md:py-20 lg:py-28'>
          <Box style={{
            zIndex: '0', display: 'grid'
          }}
            css={{
              '@sm': {
                px: '$0',
              },
            }}

          >
            <Flex
              css={{
                flexWrap: 'wrap',
                alignItems: 'center',
                zIndex: '10',
                flexDirection: 'column',
                gap: 36,
                '@bp600': {
                  flexDirection: 'row',
                  gap: 0,
                },
              }}
            >
              <Box className='order-2 lg:w-5/12 xl:w-5/12 lg:order-1 xl:order-1' css={{ alignItems: 'flex-start', '@bp600': { alignItems: 'flex-end' } }}>
                <Box className=" right-0 bottom-0 opacity-30 lg:opacity-100 z-[-1] align-middle px-4 pb-2 pt-8">
                  <img className='inset-0' src='/CryptoList.png' />
                </Box>
              </Box>
              <Box className='order-1 w-full lg:w-7/12 xl:w-7/12  lg:order-2 xl:order-2' css={{ alignItems: 'flex-start', px: '$1', textAlign: 'left', gap: 18, '@bp600': { alignItems: 'flex-end', gap: 8 } }}>
                <Flex
                  justify="between"
                  css={{
                    alignItems: 'center',
                    zIndex: '10',
                    flexDirection: 'column',
                    gap: 36,
                    '@bp600': {
                      flexDirection: 'row',
                      gap: 0,
                    },
                  }}
                >
                  <Box className="wow fadeInUp w-full mx-auto max-w-3xl mb-20 flex flex-col" data-wow-delay=".1s">
                    <Text className="mb-4 text-3xl font-bold !leading-tight sm:text-4xl md:text-[45px] text-yellow-100">Our Fixed Return Plan</Text>
                    <Text className="mb-4 text-2xl font-bold !leading-tight sm:text-3xl md:text-[35px]">Earn 30% per Monthly on Crypto & Stablecoins</Text>
                    <Text className="mb-4 text-xl font-bold !leading-tight sm:text-2xl md:text-[25px]">Deposit & Earn Interest on BTC, USDT and Other Digital Assets</Text>
                    <p className="text-base !leading-relaxed text-body-color md:text-lg">
                      Our team of experts has strategically curated these return plans, aiming to minimize your deposit risk while maximizing your returns on interest.
                    </p>
                  </Box>
                </Flex>
                <Box className='justify-center items-center text-center '>
                  <span className='relative inline-flex hover:shadow-2xl'>
                    <Anchor className='border-solid border-2 border-indigo-600 p-4 rounded-lg' href='/portal/InvestmentPlan'>Get Started
                    </Anchor>
                    <span className="flex absolute h-3 w-3 top-0 right-0 -mt-1 -mr-1">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
                    </span>
                  </span>
                </Box>
              </Box>
            </Flex>
          </Box>
          <Box className="absolute left-0 bottom-0 z-[-1] "><svg width="239" height="601" viewBox="0 0 239 601" fill="none" xmlns="http://www.w3.org/2000/svg"><rect opacity="0.3" x="-184.451" y="600.973" width="196" height="541.607" rx="2" transform="rotate(-128.7 -184.451 600.973)" fill="url(#paint0_linear_93:235)"></rect><rect opacity="0.3" x="-188.201" y="385.272" width="59.7544" height="541.607" rx="2" transform="rotate(-128.7 -188.201 385.272)" fill="url(#paint1_linear_93:235)"></rect><defs><linearGradient id="paint0_linear_93:235" x1="-90.1184" y1="420.414" x2="-90.1184" y2="1131.65" gradientUnits="userSpaceOnUse"><stop stopColor="#4A6CF7"></stop><stop offset="1" stopColor="#4A6CF7" stopOpacity="0"></stop></linearGradient><linearGradient id="paint1_linear_93:235" x1="-159.441" y1="204.714" x2="-159.441" y2="915.952" gradientUnits="userSpaceOnUse"><stop stopColor="#4A6CF7"></stop><stop offset="1" stopColor="#4A6CF7" stopOpacity="0"></stop></linearGradient></defs></svg></Box>
        </Box>
        <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2' }} className='relative z-10 py-16 md:py-20 lg:py-28'>
          <InvestmentCalc />
        </Box>
        <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2', backgroundColor: '$gray2' }} className='relative z-10 '>
          <GlobleInfo />
        </Box>
        <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2' }} className='relative z-10 py-16 md:py-20 lg:py-28'>
          <ItWork />
        </Box>
        <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2' }} id='features' className='bg-primary/[.03] py-16 md:py-20 lg:py-10 left-0 right-0'>
          <InvestmentFeatures />
        </Box>
        <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2' }} className='relative z-10 bg-primary/[.03] py-16 md:py-20 lg:py-28'>
          <UsersSay />
          <Box className="absolute top-5 right-0 z-[-1]"><svg width="238" height="531" viewBox="0 0 238 531" fill="none" xmlns="http://www.w3.org/2000/svg"><rect opacity="0.3" x="422.819" y="-70.8145" width="196" height="541.607" rx="2" transform="rotate(51.2997 422.819 -70.8145)" fill="url(#paint0_linear_83:2)"></rect><rect opacity="0.3" x="426.568" y="144.886" width="59.7544" height="541.607" rx="2" transform="rotate(51.2997 426.568 144.886)" fill="url(#paint1_linear_83:2)"></rect><defs><linearGradient id="paint0_linear_83:2" x1="517.152" y1="-251.373" x2="517.152" y2="459.865" gradientUnits="userSpaceOnUse"><stop stopColor="#4A6CF7"></stop><stop offset="1" stopColor="#4A6CF7" stopOpacity="0"></stop></linearGradient><linearGradient id="paint1_linear_83:2" x1="455.327" y1="-35.673" x2="455.327" y2="675.565" gradientUnits="userSpaceOnUse"><stop stopColor="#4A6CF7"></stop><stop offset="1" stopColor="#4A6CF7" stopOpacity="0"></stop></linearGradient></defs></svg></Box>
          <Box className="absolute left-0 bottom-5 z-[-1]"><svg width="279" height="106" viewBox="0 0 279 106" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.5"><path d="M-57 12L50.0728 74.8548C55.5501 79.0219 70.8513 85.7589 88.2373 79.3692C109.97 71.3821 116.861 60.9642 156.615 63.7423C178.778 65.291 195.31 69.2985 205.911 62.3533C216.513 55.408 224.994 47.7682 243.016 49.1572C255.835 50.1453 265.278 50.8936 278 45.3373" stroke="url(#paint0_linear_72:302)"></path><path d="M-57 1L50.0728 63.8548C55.5501 68.0219 70.8513 74.7589 88.2373 68.3692C109.97 60.3821 116.861 49.9642 156.615 52.7423C178.778 54.291 195.31 58.2985 205.911 51.3533C216.513 44.408 224.994 36.7682 243.016 38.1572C255.835 39.1453 265.278 39.8936 278 34.3373" stroke="url(#paint1_linear_72:302)"></path><path d="M-57 23L50.0728 85.8548C55.5501 90.0219 70.8513 96.7589 88.2373 90.3692C109.97 82.3821 116.861 71.9642 156.615 74.7423C178.778 76.291 195.31 80.2985 205.911 73.3533C216.513 66.408 224.994 58.7682 243.016 60.1572C255.835 61.1453 265.278 61.8936 278 56.3373" stroke="url(#paint2_linear_72:302)"></path><path d="M-57 35L50.0728 97.8548C55.5501 102.022 70.8513 108.759 88.2373 102.369C109.97 94.3821 116.861 83.9642 156.615 86.7423C178.778 88.291 195.31 92.2985 205.911 85.3533C216.513 78.408 224.994 70.7682 243.016 72.1572C255.835 73.1453 265.278 73.8936 278 68.3373" stroke="url(#paint3_linear_72:302)"></path></g><defs><linearGradient id="paint0_linear_72:302" x1="256.267" y1="53.6717" x2="-40.8688" y2="8.15715" gradientUnits="userSpaceOnUse"><stop stopColor="#4A6CF7" stopOpacity="0"></stop><stop offset="1" stopColor="#4A6CF7"></stop></linearGradient><linearGradient id="paint1_linear_72:302" x1="256.267" y1="42.6717" x2="-40.8688" y2="-2.84285" gradientUnits="userSpaceOnUse"><stop stopColor="#4A6CF7" stopOpacity="0"></stop><stop offset="1" stopColor="#4A6CF7"></stop></linearGradient><linearGradient id="paint2_linear_72:302" x1="256.267" y1="64.6717" x2="-40.8688" y2="19.1572" gradientUnits="userSpaceOnUse"><stop stopColor="#4A6CF7" stopOpacity="0"></stop><stop offset="1" stopColor="#4A6CF7"></stop></linearGradient><linearGradient id="paint3_linear_72:302" x1="256.267" y1="76.6717" x2="-40.8688" y2="31.1572" gradientUnits="userSpaceOnUse"><stop stopColor="#4A6CF7" stopOpacity="0"></stop><stop offset="1" stopColor="#4A6CF7"></stop></linearGradient></defs></svg></Box>
        </Box>
        {/* <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2' }} className='relative z-10 bg-primary/[.03] py-16 md:py-20 lg:py-28'>
          <TopInvestors />
        </Box> */}
        <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2' }} className='relative z-10 bg-primary/[.03] py-16 '>
          <ReferralPlan />
        </Box>

        <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2' }} className='relative py-8 md:py-10 lg:py-12'>
          <OpeTicket isConnected={isConnected} userId={address?.toLowerCase()} />
          <Box style={{
            position: 'absolute', opacity: '0.1',
            inset: '0',
            backgroundImage: `url(/contact-us.jpg)`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            zIndex: '0',
            filter: 'blur(0px)',
          }} />
        </Box>
        <Box css={{ borderTop: '1px solid $gray7', borderStyle: 'solid', mt: '$2' }} className='relative z-10 py-16 '>
          <PaymentMethod />
        </Box>
      </Box>
      <Footer />
    </Layout>
  )
}
export default IndexPage
